import type { CartComparisonProperty } from "../interfaces/comparisonProperty";
import { universalFetch } from "./common";

export const compareProperties = async (
	listingIds: string[],
): Promise<CartComparisonProperty> => {
	try {
		const response = await universalFetch("/listings/compare", "POST", {
			listingIds,
		});
		console.log("compare response", response);

		return response as CartComparisonProperty;
	} catch (error) {
		console.error("Failed to fetch comparableListings", error);
		throw error;
	}
};
